<template>
  
    <div class="appie-testimonial-about-area pb-45">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-5">
                    <div class="appie-section-title text-center">
                        <h3 class="appie-title">Ce que nos clients disent de nous</h3>
                        <p>Impressions des utilisateurs PlayStore..</p>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-lg-10">
                    <div class="testimonial-about-slider-active" style="position :relative">
                        <span @click.prevent="showPrev" class="prev slick-arrow" style="display: block;"><i class="fal fa-arrow-left"></i></span>
                        <VueSlickCarousel v-bind="settingsForArticle" ref="articleCarosel">
                            <div class="testimonial-parent-item">
                                <div class="testimonial-box">
                                <div class="icon">
                                    <i class="fas fa-quote-left"></i>
                                </div>
                                <div class="ratings-icon">
                                    <ul>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                    </ul>
                                </div>
                                <p>Très belle application. Surtout très pratique. Il reste à améliorer avec les assurances maladies.</p>
                            </div>
                            </div>
                            <div class="testimonial-parent-item">
                                <div class="testimonial-box">
                                <div class="icon">
                                    <i class="fas fa-quote-left"></i>
                                </div>
                                <div class="ratings-icon">
                                    <ul>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                    </ul>
                                </div>
                                <p>Très pratique et fiable</p>
                            </div>
                            </div>
                            <div class="testimonial-parent-item">
                                <div class="testimonial-box">
                                <div class="icon">
                                    <i class="fas fa-quote-left"></i>
                                </div>
                                <div class="ratings-icon">
                                    <ul>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                    </ul>
                                </div>
                                <p>Cette application m'est vraiment utile je vous le conseille vivement Meilleure application.</p>
                            </div>
                            </div>
                            <div class="testimonial-parent-item">
                                <div class="testimonial-box">
                                <div class="icon">
                                    <i class="fas fa-quote-left"></i>
                                </div>
                                <div class="ratings-icon">
                                    <ul>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                    </ul>
                                </div>
                                <p>L'application m'a été utile d'une manière inattendue...</p>
                            </div>
                            </div>
                            <div class="testimonial-parent-item">
                                <div class="testimonial-box">
                                <div class="icon">
                                    <i class="fas fa-quote-left"></i>
                                </div>
                                <div class="ratings-icon">
                                    <ul>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                    </ul>
                                </div>
                                <p>Très bonne appli je vous le conseille.</p>
                            </div>
                            </div>
                        </VueSlickCarousel>
                        <span @click.prevent="showNext" class="next slick-arrow" style="display: block;"><i class="fal fa-arrow-right"></i></span>
                    </div>
                </div>
                <div class="col-lg-4 col-md-8 col-sm-10">
                    <div class="testimonial-box-about-slider-small-active">
                        <VueSlickCarousel v-bind="settingsForPeople" ref="peopleCarosel">
                            <div class="item">
                                <div class="thumb">
                                    <img src="@/assets/images/testimonial-user-1.png" alt="">
                                </div>
                                <div class="content text-center">
                                    <h5 class="title">Freeman Dogbe</h5>
<!--                                    <span>Product Designer</span>-->
                                </div>
                            </div>
                            <div class="item">
                                <div class="thumb">
                                    <img src="@/assets/images/testimonial-user-1.png" alt="">
                                </div>
                                <div class="content text-center">
                                    <h5 class="title">Mario Dylan ADJEVI-NEGLOKPE</h5>
                                </div>
                            </div>
                            <div class="item">
                                <div class="thumb">
                                    <img src="@/assets/images/testimonial-user-1.png" alt="">
                                </div>
                                <div class="content text-center">
                                    <h5 class="title">Aa A</h5>
                                </div>
                            </div>
                            <div class="item">
                                <div class="thumb">
                                    <img src="@/assets/images/testimonial-user-1.png" alt="">
                                </div>
                                <div class="content text-center">
                                    <h5 class="title">lawson late</h5>
                                </div>
                            </div>
                            <div class="item">
                                <div class="thumb">
                                    <img src="@/assets/images/testimonial-user-1.png" alt="">
                                </div>
                                <div class="content text-center">
                                    <h5 class="title">st komlan adoletef</h5>
                                </div>
                            </div>
                        </VueSlickCarousel>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
        components:{ VueSlickCarousel},
        data(){ 
            return{
                settingsForArticle: {
                    autoplay: false,
                    arrows:false,
                    dots:false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                },
                settingsForPeople:{
                    centerMode: true,
                    centerPadding: '0px',
                    autoplay: false,
                    arrows:false,
                    dots:false,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            }
        },
        methods:{ 
            showNext() {
                this.$refs.articleCarosel.next()
                this.$refs.peopleCarosel.next()
            },
            showPrev(){
                this.$refs.articleCarosel.prev()
                this.$refs.peopleCarosel.prev()
            },
        }


}
</script>

<style>
.testimonial-about-slider-active .testimonial-box{
    margin-left: 0px !important;
    margin-right: 0px !important;
}
.slick-slide{
    padding: 0;
}

</style>